<script setup>
import {
  Collapsible,
} from '@/components/ui/collapsible';
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar';
import { useViewStore } from '@/stores/viewStore'
import { get_data_attr, generateExcel } from '@/utils/globals'

import { computed } from 'vue'
import { Square } from 'lucide-vue-next';

import axios from "axios"

const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")
if (token) axios.defaults.headers.common["X-CSRF-Token"] = token

import { useToast, Toaster } from "@/components/ui/toast"
const { toast } = useToast()


const props = defineProps({
  items: { type: Array, required: true },
  actionView: String,
  label: String,
  view: String
});

const viewStore = useViewStore()

const setView = () => {
  viewStore.setActionView(props.view)
}

import { ref } from 'vue'

const isDownloading = ref(false)

const customerInfo = get_data_attr("customer");

function performAction(url) {

  if (url === 'registry.excel') {
	console.log("performAction="+ '/excelkunde/' + customerInfo.id)
	generateExcel(axios, '/excelkunde/' + customerInfo.id, toast, isDownloading)
	return
  }
  if (url === 'registry.rechtsgrundlagen' || url === 'registry.pflichten') {
    viewStore.markLegalNavReset()
  }
  viewStore.setActionView(url)
}
</script>

<template>
    <SidebarMenu>
      <Collapsible
        v-for="item in items"
        :key="item.title"
        as-child
        :default-open="item.isActive"
        class="group/collapsible"
      >
        <SidebarMenuItem>
            <SidebarMenuButton @click="performAction(item.url)"  :tooltip="item.title"  :isActive="viewStore.actionView === item.url">				
				<component :is="item.icon" v-if="item.icon" :style="{ width: '20px', height: '20px' }" />
				<span>{{ item.title }}</span>
            </SidebarMenuButton>
			<div v-if="item.url === 'registry.excel' && isDownloading" class="spinner">Excel wird generiert...</div>
        </SidebarMenuItem>
      </Collapsible>
    </SidebarMenu>
</template>
